export default {
  schemelist: '/api/v1/schemes/search',
  etfList: '/api/v1/share-market/quick-links/all/nse/3',
  userLogout: '/api/users/me',
  userDetails: '/api/users/me',
  userInvestments: '/api/v1/dashboard/portfolio',
  fundBalance: '/api/v1/fund/limit',
  stocks: '/api/v1/stocks/',
  hvGetToken: '/api/v1/onboarding/generate-token',
  hvUpdateEmail: '/api/onboardings/modifications/email',
  hvUpdatePhone: '/api/onboardings/modifications/phone',
  hvUpdateBank: '/api/onboardings/modifications/bank',
  hvUpdateSegment: '/api/onboardings/modifications/segment',
  userBankDetails: '/api/v1/customers',
  iyiPortfolio: '/api/v1/dashboard/portfolio/iyi',
  techExcelProfile: '/api/users/techexcel-profile',
  fundLimit: '/payments/api/v1/fund-limit',
};
